import React from "react";
import styled from "styled-components";

const TabNavContainer = styled.div`
  display: flex;
  border-bottom: 1px solid #ccc;
  margin-top: 10px;
  margin-bottom:10px;
`;

const Tab = styled.div`
  padding: 10px 20px;
  cursor: pointer;
  ${(props) =>
    props.active &&
    `
      border-bottom: 2px solid #007bff;
      font-weight: bold;
      color: #007bff;
    `}
`;

const TabNavigation = ({ activeTab, setActiveTab }) => {
  return (
    <TabNavContainer>
      <Tab
        active={activeTab === "surveyQuestions"}
        onClick={() => setActiveTab("surveyQuestions")}
      >
        Survey Questions
      </Tab>
      <Tab
        active={activeTab === "aisettings"}
        onClick={() => setActiveTab("aisettings")}
      >
        AI Settings
      </Tab>
      <Tab
        active={activeTab === "factorSettings"}
        onClick={() => setActiveTab("factorSettings")}
      >
        Factor Settings
      </Tab>
      <Tab
        active={activeTab === "languages"}
        onClick={() => setActiveTab("languages")}
      >
        Languages
      </Tab>
    </TabNavContainer>
  );
};

export default TabNavigation;
